import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import pkg from '../../package.json';
import CookiesPolicy from '../views/cookies-policy.vue';
import ServiceDiagnostics from '../views/service-diagnostics.vue';
import CashlessRepairs from '../views/cashless-repairs.vue';
import PostCrashRepairs from '../views/post-crash-repairs.vue';
import Error404 from '../views/error-404.vue';
import Home from '../views/home.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/serwis-diagnostyka-samochodow',
    name: 'service-diagnostics',
    component: ServiceDiagnostics,
    meta: { title: 'Diagnostyka i serwis' },
  },
  {
    path: '/naprawy-powypadkowe',
    name: 'post-crash-repairs',
    component: PostCrashRepairs,
    meta: { title: 'Naprawy powypadkowe' },
  },
  {
    path: '/naprawy-bezgotowkowe',
    name: 'cashless-repairs',
    component: CashlessRepairs,
    meta: { title: 'Naprawy bezgotówkowe' },
  },
  {
    path: '/polityka-cookies',
    name: 'cookies',
    component: CookiesPolicy,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error-404',
    component: Error404,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active',
  // https://router.vuejs.org/guide/advanced/scroll-behavior.html
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
      };
    }

    if (savedPosition) {
      return savedPosition;
    }

    return { left: 0, top: 0 };
  },
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} | ${pkg.description}` : pkg.description;
});

export default router;
